import { NotifyHelper } from "../../../helpers/toast"
import { ePageBaseStatus } from "../../../models/ePageBaseStatus"
import { eAppMenuActionTypeIds, IAppMenuActionTypes } from "../../action-types/app-phuhuynh/IAppMenuActionTypes"
import { IAppMenuPageState } from "../../page-state-model/app-phuhuynh/IAppMenuPageState"

const initialState: IAppMenuPageState = {
    status: ePageBaseStatus.is_not_initialization,
    app_menus: [],
    app_menu_selected_ids: [],
    app_menu_editing: undefined,
    is_show_delete_confirm: false,
    is_show_detail_modal: false
}

export const appMenuReducer = (state: IAppMenuPageState = initialState, action: IAppMenuActionTypes): IAppMenuPageState => {
    switch (action.type) {
        case eAppMenuActionTypeIds.LOAD_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case eAppMenuActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                app_menus: action.payload
            }
        case eAppMenuActionTypeIds.LOAD_ERROR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                app_menus: []
            }
        case eAppMenuActionTypeIds.SHOW_DETAIL:
            return {
                ...state,
                is_show_detail_modal: true,
                app_menu_editing: action.payload
            }
        case eAppMenuActionTypeIds.CLOSE_DETAIL:
            return {
                ...state,
                is_show_detail_modal: false,
                app_menu_editing: undefined
            }
        case eAppMenuActionTypeIds.CHANGE_SELECTED_IDS:
            return {
                ...state,
                app_menu_selected_ids: action.payload
            }
        case eAppMenuActionTypeIds.SHOW_CONFIRM:
            return {
                ...state,
                is_show_delete_confirm: true
            }
        case eAppMenuActionTypeIds.CLOSE_CONFIRM:
            return {
                ...state,
                is_show_delete_confirm: false
            }
        
            case eAppMenuActionTypeIds.DELETE_START:
                return {
                    ...state,
                    status: ePageBaseStatus.is_deleting
                }
            case eAppMenuActionTypeIds.DELETE_SUCCESS:
                NotifyHelper.Success("Xoá dữ liệu thành công.")
                return {
                    ...state,
                    status: ePageBaseStatus.is_completed,
                    is_show_delete_confirm:false
                }
            case eAppMenuActionTypeIds.DELETE_ERROR:
                NotifyHelper.Error(action.payload)
                return {
                    ...state,
                    status: ePageBaseStatus.is_completed,
                    is_show_delete_confirm:false
                }

        
            case eAppMenuActionTypeIds.SAVE_START:
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case eAppMenuActionTypeIds.SAVE_SUCCESS:
            NotifyHelper.Success("Thay đổi dữ liệu thành công.")
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                is_show_detail_modal:false
            }
        case eAppMenuActionTypeIds.SAVE_ERR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                is_show_detail_modal:false
            }

        default:
            return state;
    }

}